export default "__VITE_ASSET__tNhuhs2f__"